import { databaseKey } from "../common/database_key";
import { fetchData, subscribeToData } from "../firebase/firebase_methods";
import "../../assets/css/mobile_banner.css";

export const fetchBanners = async (setBanners, setLoading) => {
  document.body.classList.remove("banner-visible");

  try {
    const collectionName = databaseKey();
    if (collectionName) {
      const bannersRef = fetchData(`${collectionName}/banner`);

      const unsubscribe = subscribeToData(bannersRef, (data) => {
        if (data) {
          const bannerArray = Object.keys(data)
            .map((key) => ({
              id: key,
              ...data[key],
            }))
            .filter((banner) => {
              const bannerDate = new Date(banner.timestamp);
              const currentDate = new Date();
              const expiryDate = new Date(bannerDate);
              expiryDate.setDate(bannerDate.getDate() + banner.expiry);

              return (
                banner.paymentStatus === "success" &&
                banner.approved === "true" &&
                currentDate <= expiryDate
              );
            });

          if (bannerArray.length > 0) {
            setBanners(bannerArray);
            document.body.classList.remove("banner-visible");
          } else {
            setBanners([]);
            document.body.classList.add("banner-visible");
          }
        } else {
          setBanners([]);
          document.body.classList.add("banner-visible");
        }

        setLoading(false);
      });

      return () => unsubscribe();
    }
  } catch (error) {
    console.error("Error fetching banners:", error);
    setBanners([]);
    document.body.classList.add("banner-visible");
    setLoading(false);
  }
};

export const handleDismiss = (setBanners, setCurrentIndex) => {
  setBanners([]);
  setCurrentIndex(0);
  document.body.classList.add("banner-visible");
};
